import { UserSearchTextConfig } from '../components/user-search/user-search.types';

export const DEFAULT_USER_SEARCH_TEXT_CONFIG: UserSearchTextConfig = {
    header: {
        title: 'general.scd-picker.dialog.title',
        text: 'general.scd-picker.dialog.subtitle'
    },
    searchBar: {
        firstName: 'general.scd-picker.dialog.labels.firstName',
        lastName: 'general.scd-picker.dialog.labels.lastName',
        gid: 'general.scd-picker.dialog.labels.gid'
    },
    search: {
        table: {
            name: 'general.scd-picker.dialog.table.header.name',
            gid: 'general.scd-picker.dialog.table.header.gid',
            department: 'general.scd-picker.dialog.table.header.department'
        },
        error: 'general.scd-picker.dialog.errors.loading',
        empty: 'general.scd-picker.dialog.noResults'
    }
};
